module.exports = __webpack_public_path__ + "img/png11.7960e43c.png";